/**
 * Holds the access token in a module variable — deliberately NOT in
 * localStorage.
 *
 * Anything in localStorage is readable by any script on the page, so a single
 * XSS bug hands over the token. Keeping it in memory means a page refresh
 * loses it, which is fine: the httpOnly refresh cookie silently restores the
 * session on boot (see `useSessionBootstrap`).
 *
 * This lives outside the zustand store so `apiClient` can read the token
 * without importing the store, which would create a circular import.
 */
let accessToken: string | null = null;

/** Called when the session is unrecoverable, so the app can redirect to login. */
let onSessionExpired: (() => void) | null = null;

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string | null): void => {
    accessToken = token;
  },
  clear: (): void => {
    accessToken = null;
  },
  onExpired: (handler: () => void): void => {
    onSessionExpired = handler;
  },
  notifyExpired: (): void => {
    accessToken = null;
    onSessionExpired?.();
  },
};
